<template>
  <div class="container"><div v-html="useragree"></div></div>
    
</template>

<script>
import { agreemen } from '../api/api';
export default {
   name: 'useragreement',
 data() {
    return {
       useragree:""
    }
  },
  mounted() {
    agreemen({
        type: 0,
      }).then(res => {
        if (res.data.code == 200) {

          this.useragree = res.data.result.content
       
        }
      });
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin-top: 10px;
  padding: 30px
}
</style>
 


// WEBPACK FOOTER //
// src/components/useragreement.vue